import anime from 'animejs/lib/anime.es.js';

const hoverAnimation = () => {
  let hoverBlocks = document.querySelectorAll('.programs-block'),
    hoverElements = document
      ?.querySelector('.programs')
      ?.getElementsByTagName('img');

  function checkHoverBlocks(el, idx) {
    if (idx < 1) {
      animateImgHover_1(el);
    } else if (idx >= 1) {
      animateImgHover_2(el);
    }
  }

  function checkDefault(el, idx) {
    if (idx < 1) {
      animateImgDefault_1(el);
    } else if (idx >= 1) {
      animateImgDefault_2(el);
    }
  }

  function animateImgHover_1(it) {
    anime({
      targets: it[0],
      opacity: 1,
      translateX: -15,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
    anime({
      targets: it[1],
      opacity: 1,
      translateX: 8,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
    anime({
      targets: it[2],
      opacity: 1,
      translateY: -4,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
  }
  function animateImgHover_2(it) {
    anime({
      targets: it[4],
      opacity: 1,
      translateY: -28,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
    anime({
      targets: it[5],
      opacity: 1,
      translateY: -14,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
  }
  function animateImgDefault_1(it) {
    anime({
      targets: it[0],
      opacity: 1,
      translateX: 0,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
    anime({
      targets: it[1],
      opacity: 1,
      translateX: 0,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
    anime({
      targets: it[2],
      opacity: 1,
      translateY: 0,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
  }
  function animateImgDefault_2(it) {
    anime({
      targets: it[4],
      opacity: 1,
      translateY: 0,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
    anime({
      targets: it[5],
      opacity: 1,
      translateY: 0,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
  }

  [...hoverBlocks].forEach((it, idx) => {
    it.addEventListener('mouseover', function () {
      checkHoverBlocks([...hoverElements], idx);
    });
    it.addEventListener('mouseout', function () {
      checkDefault([...hoverElements], idx);
    });
  });
};

export default hoverAnimation;
